import React, { Children, useEffect, useState, useRef, useMemo } from 'react'

import classes from "../Camect/CametContentLayout.module.css";
import Modal from '../Camect/CamectCameraModal';
import { useDispatch, useSelector } from 'react-redux';
import OTPIcon from "../../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/__Access.svg";
import RemoveCamectIcon from "../../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/DropDown Icons/__Delete - Remove.svg"
import GenerateLockOnTimePassCodeForm from '../../EditAutomations/GenerateLockOnTimePassCodeForm';
import { clearDeviceLogs, deleteCamectAPI, deleteDavantisAPI, GenerateLockOTP, GenerateLockOTPAPI, getCamectCameras, getCamectsAPI, getDavantisesAPI, removeLockAPI, updateCamectRelationshipAPI, updateDavantisRelationshipAPI } from '../../../../../../Api Methods/Api';

import LinkIcon from "../../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/link.png"
import EditIcon from "../../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/DropdownIcons/changeTag.png"
import RefreshIcon from "../../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Camect/__Refresh.svg"
import Button2 from '../../../../Button/Button2';
import Button1 from '../../../../Button/Button1';
import DeviceCard from '../../../Devices/DeviceCard';
import { Button } from 'primereact/button';

const DavantisContentLayout = ({ davantis, LinkedPins, fetchVirtualSources, HandleSelectCamectModalForm, Outputs }) => {

    console.log(davantis)
    console.log(LinkedPins)

    let { id: davantisID, username, address, password } = davantis;
    const PinName = LinkedPins[0] ? LinkedPins[0].pinName : "Not Linked";
    const client = useSelector(state => state.auth.client);
    const token = useSelector(state => state.auth.token);
    const DeviceUUID = useSelector(state => state.auth.DeviceUUID);
    const [loading, setLoading] = useState(false); // Load

    const apiData = {
        token,
        client
    }

    const HandleShowModal = () => {
        setShowModal(true);
    }

    const ShowSave = () => {
        setShowSave(true);
    }

    const HandleCloseModal = () => {
        setShowModal(false);
        setShowSave(false);
        HandelResetModal();
        setIsHightlighted(false)
        setSelectedCameras([])
        setNeedsHighlighted(true)
        setShowError(false)
    }

    const [modalTitle, setModalTitle] = useState("SmartLock")
    const [modalComponent, setModalComponent] = useState(null);
    const [modalPageIndex, setModalPageIndex] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [showSave, setShowSave] = useState(false);
    const [chosenPinName, setChosenPinName] = useState()

    const [showAddCamect, setShowAddCamect] = useState(false);
    const [camectCameras, setCamectCameras] = useState();
    const [camectCameraPin, setCamectCameraPin] = useState();
    const [selectedCameras, setSelectedCameras] = useState([]);
    const memoizedSelectedCameras = useMemo(() => selectedCameras, [selectedCameras]);
    const [linkedPinNames, setLinkedPinNames] = useState([])
    const [isHighlighted, setIsHightlighted] = useState(false)
    const [needsHighlighted, setNeedsHighlighted] = useState(true)
    const [currentPinIsOutput, setCurrentPinIsOutput] = useState(null)
    const [showError, setShowError] = useState(false)

    const outputs = ['5', '6', '13', '19']
    const inputs = ['21', '20', '16', '12', '4', '3', '2', '1']

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                HandelResetModal();
            }
        };
        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    const HandelResetModal = () => {
        setShowAddCamect(null);
        setModalPageIndex(null);
        setSelectedCameras([]);
        setIsHightlighted(false)
        setLoading(false)
        setShowError(false)
    }

    const dispatch = useDispatch();
    const DeviceDetails = useSelector(state => state.service.DeviceDetails)

    const handleShowAddDavantisForm = () => {
        HandleCloseModal();
        HandleSelectCamectModalForm(3, davantis)
    }

    useEffect(() => {
        switch (modalPageIndex) {
            case 1:
                setModalTitle("")
                setModalComponent(
                    <div  style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: "10px"
                      }}>
                        
                        <Button label="Edit Davantis" rounded severity='secondary' onClick={handleShowAddDavantisForm}/>
                       
                        <Button label="Delete Davantis" rounded severity='danger' onClick={HandleDeleteDavantis}/>
            
                    </div>
                )
                HandleShowModal();
                break;
            case 2:
                setModalTitle("Link switch")
                setModalComponent(
                        <div>
                        {loading && (
                            <div className={classes.loadingOverlay}>
                            <div className={classes.loadingSpinner}></div></div>
                        )}
                        <ul className={classes.PinsList}>
                            {Outputs.map((output) => (
                                <li>
                                    <Button2 style={{ 
                                        minWidth: "350px", 
                                        minHeight: "40px", 
                                        display: "flex", 
                                        justifyContent: "center", 
                                        alignItems: "center"
                                        }
                                    }   
                                        onClick={() => LinkDavantis(output.Pin, output.pinName)}>
                                            {output.pinName}
                                    </Button2>
                                </li>
                            ))}
                        </ul>
                    </div>
                )
                HandleShowModal();
                break;
            case 3:
                setModalComponent(<>3</>)
                HandleShowModal();
                break;
            
            }

        }, [modalPageIndex, memoizedSelectedCameras, loading, showError])

    const HandleDeleteDavantis = async () => {
        if (LinkedPins.length != 0) {
            setModalTitle("Important!");
            setModalComponent(
                <div style={{ display: "flex", flexDirection: "column", alignItems: "content", justifyContent: "center", width: "100%", gap: "20px" }}>
                    <div style={{ display: "flex", alignItems: "content", justifyContent: "center", width: "100%", gap: "3px" }}>
                        <h4 style={{ margin: "0px" }}>{"Please unlink this camect from all switches/inputs before deletion"}</h4>
                    </div>
                    <div style={{ display: "flex", alignItems: "content", justifyContent: "center", width: "100%", gap: "10px" }}>
                        <Button1 propsclassName={classes.CancelButton} onClick={HandleCloseModal}>Cancel</Button1>
                    </div>
                </div>
            )
        }
        else {
            console.log("here")
            const responseData = await deleteDavantisAPI(apiData, DeviceUUID, davantisID, dispatch);
            if (responseData.message == "sent") {
                HandleCloseModal();
                fetchVirtualSources();
            }
        }
    }

    const LinkDavantis = async (Pin, pinName) => {
        
        const pin = Pin.toString();
        const camectDetails = {
            "uuid": DeviceUUID,
            "id": davantisID,       //The ID of the camect (set to "" if removing)
            "pin": pin
        }

       
            const responseData = await updateDavantisRelationshipAPI(apiData, camectDetails, dispatch);
            if (responseData) {
                HandleCloseModal();
                fetchVirtualSources();
            }
        }


    const getPinName = (pinNumber) => {
        const pinNumberInt = parseInt(pinNumber, 10);
        const output = Outputs.find(output => output.Pin === pinNumberInt);
        return output ? output.pinName : null;
    };

    const getPinNumber = (pinName) => {
        const pin = Outputs.find(output => output.pinName === pinName);
        return pin ? String(pin.Pin) : null
    }

    const getDavantisRelationships = async () => {
        const davantisesAndRelationships = await getDavantisesAPI(apiData, DeviceUUID, dispatch)
        return davantisesAndRelationships
    }

    const removeLinkedPin = async (Pin) => {
        const pin = Pin.toString();
        const camectDetails = {
            "uuid": DeviceUUID,
            "id": '',       //The ID of the camect (set to "" if removing)
            "pin": pin
        }

        console.log(apiData)
        console.log(camectDetails)

        const responseData = await updateDavantisRelationshipAPI(apiData, camectDetails, dispatch)
        if (responseData) {
            HandleCloseModal();
            fetchVirtualSources();
        }
    }

    const HandleShowLinkedPins = () => {
        setModalTitle("Unlink Switches/Inputs")
        setModalComponent(
            <ul className={classes.PinsList}>
                {LinkedPins.map((LinkedPin) => {
                    return (
                        <li>
                            <Button2 onClick={() => removeLinkedPin(LinkedPin.Pin)}
                                img={RemoveCamectIcon}>
                                {LinkedPin.pinName}
                            </Button2>
                        </li>
                    )
                })}
            </ul>
        )
        HandleShowModal();
    }

    return (
        <>
           
                <Modal show={showModal} onClose={HandleCloseModal} title={modalTitle} save={showSave} onSave={""}>
                    {modalComponent}
                </Modal>
            
            
            {/* <Modal ref={ModalDialog} title={modalTitle} HandleShowModal={HandleShowModal} HandleCloseModal={HandleCloseModal} style={{ minWidth: "600px", minHeight: "270px"}} modalLayoutStyle={{ alignItems: "center" }}>
                {modalComponent}
            </Modal> */}

            <DeviceCard
                header={`Davantis`}
                meta={[address]}
                onClick={() => HandleShowLinkedPins()}
                rightContent={
                    <>
                        <div style={{alignItems:"flex-end"}}>
                            <h3 style={{color:"var(--Primary-Color)", marginBottom:"5px"}}>{PinName}</h3>
                            {LinkedPins.length > 1 && <h4 className={classes.subPinText}> + {LinkedPins.length - 1} more</h4>}
                            <div style={{
                                marginTop:"5px",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "flex-end"
                            }}>
                                <img style={{ width: "25px", cursor:"pointer"}} title="Edit Davantis" src={EditIcon} onClick={() => setModalPageIndex(1)} />
                                <img style={{ width: "25px", cursor:"pointer"}} title="Link Davantis to a switch" src={LinkIcon} onClick={() => setModalPageIndex(2)} />
                            </div>
                        </div>
                    </>
                } 
            />
        </>
    )
}

export default DavantisContentLayout;




